import { createSlice } from "@reduxjs/toolkit";
import { getCommissionList, addCommission, updateCommission } from "./ThunkAction";
import { iCommissionState, REDUCER_NAME } from "./Types";

const initialState: iCommissionState = {
  isLoading: false,
  commissionList: [],
  errorMessage: null,
};

export const commissionSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetCommissionState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Commission List
      .addCase(getCommissionList.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getCommissionList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.commissionList = payload.data;
          state.isLoading = false;
          state.errorMessage = null;
        }
      })
      .addCase(getCommissionList.rejected, (state, action) => {
        //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to fetch Commission data";
        state.isLoading = false;
      })

      // Add Commission
      .addCase(addCommission.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(addCommission.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(addCommission.rejected, (state, action) => {
        // ✅ Extract error message properly
          //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to add Commission";
        state.isLoading = false;
      })

      // Update Commission
      .addCase(updateCommission.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(updateCommission.fulfilled, (state, action) => {
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(updateCommission.rejected, (state, action) => {
        // ✅ Extract error message properly
          //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to update Commission";
        state.isLoading = false;
      });
  },
});

export const { resetCommissionState } = commissionSlice.actions;
export default commissionSlice.reducer;